// src/useParallax.js
import { useEffect } from "react";

function useParallax() {
  useEffect(() => {
    // Get all the elements with the "data-parallax" attribute
    const parallaxElements = document.querySelectorAll("[data-parallax]");

    // Handle the scroll event and adjust the transform property for each parallax element
    const handleScroll = () => {
      parallaxElements.forEach((element) => {
        // Get the position of the element relative to the viewport
        const rect = element.getBoundingClientRect();

        // Get the scrollY value, which is the current scroll position
        const scrollY = window.scrollY;

        // Calculate the offset from the top of the element to the viewport
        const offset = rect.top;

        // Initial starting position above the viewport to make the image start higher
        // Let's start it 150px above the top of the viewport to give the feeling of moving downwards
        const initialPosition = -250;

        // Adjust the speed of the parallax effect here (e.g., 0.3, 0.5)
        const parallaxSpeed = (scrollY - offset) * 0.3; // Adjust speed dynamically based on scroll

        // Apply the initial offset along with the scroll movement
        element.style.transform = `translateY(${initialPosition + parallaxSpeed}px)`;
      });
    };

    // Add the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array to run this effect once on mount
}

export default useParallax;
